// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { GetUmbracoFormsDeliveryApiV1DefinitionsByIdData, GetUmbracoFormsDeliveryApiV1DefinitionsByIdResponses, GetUmbracoFormsDeliveryApiV1DefinitionsByIdErrors, PostUmbracoFormsDeliveryApiV1EntriesByIdData, PostUmbracoFormsDeliveryApiV1EntriesByIdResponses, PostUmbracoFormsDeliveryApiV1EntriesByIdErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class FormsService {
    public static getUmbracoFormsDeliveryApiV1DefinitionsById<ThrowOnError extends boolean = false>(options: Options<GetUmbracoFormsDeliveryApiV1DefinitionsByIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUmbracoFormsDeliveryApiV1DefinitionsByIdResponses, GetUmbracoFormsDeliveryApiV1DefinitionsByIdErrors, ThrowOnError>({
            url: '/umbraco/forms/delivery/api/v1/definitions/{id}',
            ...options
        });
    }
    
    public static postUmbracoFormsDeliveryApiV1EntriesById<ThrowOnError extends boolean = false>(options: Options<PostUmbracoFormsDeliveryApiV1EntriesByIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostUmbracoFormsDeliveryApiV1EntriesByIdResponses, PostUmbracoFormsDeliveryApiV1EntriesByIdErrors, ThrowOnError>({
            url: '/umbraco/forms/delivery/api/v1/entries/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}